/**
 * 当前这个域名是不是工厂端。
 *
 * **为什么这里必须看域名，而不是像别处一样看 session。**
 *
 * 开发文档定的是「租户身份从 session 来，不从域名来」，那句话对 —— 但只对
 * **已登录之后**。未登录的时候 session 里什么都没有，而这一刻恰恰要决定给谁看哪个
 * 登录入口：工厂该看到微信，内部人员该看到飞书。此时域名是**唯一**能用的信号。
 *
 * 也就是说身份解析是两个问题不是一个：
 *   已登录 → 看 session（tenant_id 决定挂哪组路由）
 *   未登录 → 看域名（决定给哪个登录页）
 * 之前把后一半也套了前一半的规则，结果工厂端域名上挂了个飞书登录按钮。
 *
 * 这**不是安全边界**。真正的边界在后端（scopeFilter + G3 出口闸），
 * 内部人员的 session cookie 种在 sitebox.globalyiwu.com 上，跨不到 link4a.com。
 * 这里只决定给谁看什么，别当墙用。
 */

/** 逗号分隔，可用 VITE_GENBOX_PORTAL_HOSTS 覆盖；不配就按 `portal.` 前缀判 */
function configuredHosts(env: Record<string, string | undefined>): string[] {
  return (env['VITE_GENBOX_PORTAL_HOSTS'] ?? '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

export function isPortalHost(
  hostname: string = typeof window === 'undefined' ? '' : window.location.hostname,
  env: Record<string, string | undefined> = import.meta.env as unknown as Record<
    string,
    string | undefined
  >,
): boolean {
  const host = hostname.toLowerCase();
  if (!host) return false;
  const configured = configuredHosts(env);
  if (configured.length > 0) return configured.includes(host);
  return host === 'portal' || host.startsWith('portal.');
}
